import { render, staticRenderFns } from "./IcoFeeling.vue?vue&type=template&id=6a2314fc&scoped=true"
import script from "./IcoFeeling.vue?vue&type=script&lang=js"
export * from "./IcoFeeling.vue?vue&type=script&lang=js"
import style0 from "./IcoFeeling.vue?vue&type=style&index=0&id=6a2314fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2314fc",
  null
  
)

export default component.exports